import { render, staticRenderFns } from "./textBookList.vue?vue&type=template&id=0cd00d8e&scoped=true&"
import script from "./textBookList.vue?vue&type=script&lang=js&"
export * from "./textBookList.vue?vue&type=script&lang=js&"
import style0 from "./textBookList.vue?vue&type=style&index=0&id=0cd00d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd00d8e",
  null
  
)

export default component.exports